// Mirror of:  https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/EmailType.java
export const EMAIL_TYPE = {
  BATCH_EMAIL: 'BATCH_EMAIL',
  AB_EMAIL: 'AB_EMAIL',
  AUTOMATED_AB_EMAIL: 'AUTOMATED_AB_EMAIL',
  AUTOMATED_EMAIL: 'AUTOMATED_EMAIL',
  BLOG_EMAIL: 'BLOG_EMAIL',
  BLOG_EMAIL_CHILD: 'BLOG_EMAIL_CHILD',
  FOLLOWUP_EMAIL: 'FOLLOWUP_EMAIL',
  LOCALTIME_EMAIL: 'LOCALTIME_EMAIL',
  OPTIN_EMAIL: 'OPTIN_EMAIL',
  OPTIN_FOLLOWUP_EMAIL: 'OPTIN_FOLLOWUP_EMAIL',
  RESUBSCRIBE_EMAIL: 'RESUBSCRIBE_EMAIL',
  RSS_EMAIL: 'RSS_EMAIL',
  RSS_EMAIL_CHILD: 'RSS_EMAIL_CHILD',
  SINGLE_SEND_API: 'SINGLE_SEND_API',
  LEADFLOW_EMAIL: 'LEADFLOW_EMAIL',
  FEEDBACK_NPS_EMAIL: 'FEEDBACK_NPS_EMAIL',
  FEEDBACK_CES_EMAIL: 'FEEDBACK_CES_EMAIL',
  FEEDBACK_CUSTOM_EMAIL: 'FEEDBACK_CUSTOM_EMAIL',
  FEEDBACK_CUSTOM_SURVEY_EMAIL: 'FEEDBACK_CUSTOM_SURVEY_EMAIL',
  TICKET_EMAIL: 'TICKET_EMAIL',
  SMTP_TOKEN: 'SMTP_TOKEN',
  MEMBERSHIP_REGISTRATION_EMAIL: 'MEMBERSHIP_REGISTRATION_EMAIL',
  MEMBERSHIP_PASSWORD_SAVED_EMAIL: 'MEMBERSHIP_PASSWORD_SAVED_EMAIL',
  MEMBERSHIP_PASSWORD_RESET_EMAIL: 'MEMBERSHIP_PASSWORD_RESET_EMAIL'
};
export const AUTOMATED_LIKE = [EMAIL_TYPE.AUTOMATED_EMAIL, EMAIL_TYPE.AUTOMATED_AB_EMAIL, EMAIL_TYPE.FEEDBACK_CES_EMAIL, EMAIL_TYPE.FEEDBACK_NPS_EMAIL, EMAIL_TYPE.FEEDBACK_CUSTOM_EMAIL, EMAIL_TYPE.FEEDBACK_CUSTOM_SURVEY_EMAIL, EMAIL_TYPE.SMTP_TOKEN, EMAIL_TYPE.LEADFLOW_EMAIL, EMAIL_TYPE.OPTIN_EMAIL, EMAIL_TYPE.SINGLE_SEND_API, EMAIL_TYPE.OPTIN_FOLLOWUP_EMAIL, EMAIL_TYPE.FOLLOWUP_EMAIL, EMAIL_TYPE.RESUBSCRIBE_EMAIL, EMAIL_TYPE.TICKET_EMAIL, EMAIL_TYPE.MEMBERSHIP_REGISTRATION_EMAIL, EMAIL_TYPE.MEMBERSHIP_PASSWORD_SAVED_EMAIL, EMAIL_TYPE.MEMBERSHIP_PASSWORD_RESET_EMAIL];
export const MIN_PERCENTAGE_DISPLAY = 20;
export const DEFAULT_REVENUE_RESPONSE = {
  metrics: {
    hs_contact_id: {
      distinctApprox: 0
    },
    hs_deal_id: {
      distinctApprox: 0
    },
    hs_linear_amount: {
      sum: 0
    }
  }
};
export const LIST_PROPERTIES = {
  LIST_SIZE: 'hs_list_size',
  LIST_NAME: 'hs_list_name',
  LIST_CLASSIC_ID: 'hs_classic_list_id',
  LIST_TYPE: 'hs_processing_type',
  PROCESSING_STATUS: 'hs_processing_status',
  DELETED_AT: 'hs_deleted_at',
  INBOUND_LIST_ID: 'hs_list_id',
  CREATED_AT: 'hs_created_at',
  UPDATED_AT: 'hs_updated_at',
  OBJECT_TYPE_ID: 'hs_object_type_id'
};
export const INBOUND_LIST_PROPERTIES = Object.values(LIST_PROPERTIES);